import BasicResource from '@/api/resource';

class Resource extends BasicResource {

    constructor () {
        super('offers');
    }

    groupedList (payload) {
        return this.client.request ({
            method: 'get',
            path: '/publisher/v1/offers/groups',
            params: payload.params,
        });
    }

    bannersList (id) {
        return this.client.request ({
            method: 'get',
            path: `/publisher/v1/offers/${id}/banners`,
        });
    }

    capsList (id) {
        return this.client.request ({
            method: 'get',
            path: `/publisher/v1/offers/${id}/caps`,
        });
    }

    revenuesList (id) {
        return this.client.request ({
            method: 'get',
            path: `/publisher/v1/offers/${id}/revenues`,
        });
    }

    dict (params) {
        return this.client.request ({
            method: 'get',
            path: '/publisher/v1/dict/offers',
            params: params,
        });
    }

    payouts (id, params = {}) {
        return this.client.request ({
            method: 'get',
            path: `/publisher/v1/offers/${id}/payouts`,
            params: params,
        });
    }

    fetchImagePreview (payload) {
        return this.client.request ({
            method: 'post',
            path: '/publisher/v1/offers/fetch-preview',
            data: payload,
        });
    }

    uploadImagePreview (id, payload) {
        return this.client.request ({
            method: 'put',
            path: `/publisher/v1/offers/${id}/upload`,
            data: payload,
        });
    }

    activate (offerId) {
        return this.client.request ({
            method: 'put',
            path: `/publisher/v1/offers/${offerId}/unpause`,
        });
    }

    pause (offerId) {
        return this.client.request ({
            method: 'put',
            path: `/publisher/v1/offers/${offerId}/pause`,
        });
    }

    apply (offerId) {
        return this.client.request ({
            method: 'post',
            path: `/publisher/v1/offers/${offerId}/apply`,
        });
    }

    run (offerId) {
        return this.client.request ({
            method: 'post',
            path: `/publisher/v1/offers/${offerId}/run`,
        });
    }

    download (data) {
        const { sort, limit, offset, ...params } = { ...data };

        return this.client.download ({
            method: 'get',
            path: '/publisher/v1/offers/download',
            params,
        });
    }

    downloadBanners (offerId) {
        return this.client.download ({
            method: 'get',
            path: `/publisher/v1/offers/${offerId}/download-banners`,
        });
    }

    featuredList (params = {}) {
        return this.client.request({
            method: 'get',
            path:   '/publisher/v1/offers/featured',
            params: params,
        });
    }
}

export default new Resource;
